import {
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { TokenInterceptor } from './shared/service/token-interceptor';
import { AppRoutingModule } from './app.routes';
import { LoginService, AuthService } from './shared/service';
import { AlertService } from './shared/service/alert.service';
import { AuthGuard } from './shared/guard';
import { ContactImportService } from './shared/service/contact-import.service';
import { VCardService } from './shared/service/vcard.service';
import { MiscService } from './shared/service/misc.service';
import { ConnectivityService } from './shared/service/connectivity.service';
import { WindowRef } from './shared/misc/windowRef';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AsyncPipe } from '@angular/common';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    // BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    // CountryPickerModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AsyncPipe,
    WindowRef,
    LoginService,
    AlertService,
    AuthService,
    AuthGuard,
    ContactImportService,
    VCardService,
    MiscService,
    ConnectivityService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
